import updateSelects from "./selects";
import updateKanban from "./kanban";
import updateCalendar from "./calendar";
import updateClient from "./clients";
import updateChildren from "./children";
import updateAuth from "./auth";
import updateDiscount from "./discounts";
import updateTask from "./task";
import updateMainScreen from "./main-screen";
import updateAdmins from "./admin";
import updateTrainer from "./trainer";
import updateAnalytic from "./analytic";
import updatePaymentProfile from "./payment-profile";

const reducer = (state, action) => {
  return {
    kanban: updateKanban(state, action),
    calendar: updateCalendar(state, action),
    clients: updateClient(state, action),
    selects: updateSelects(state, action),
    children: updateChildren(state, action),
    auth: updateAuth(state, action),
    discount: updateDiscount(state, action),
    tasks: updateTask(state, action),
    desktop: updateMainScreen(state, action),
    admin: updateAdmins(state, action),
    trainer: updateTrainer(state, action),
    analytic: updateAnalytic(state, action),
    paymentProfile: updatePaymentProfile(state, action),
  };
};

export default reducer;
